import type { DataSettingsManager } from '@wix/wix-data-client-common-standalone'
import { AppCollectionVisibility } from '@wix/wix-data-client-common-standalone'

/**
 * @deprecated dataSettings should be used directly https://jira.wixpress.com/browse/WD-7989
 */
export default function createAppCollectionVisibilityPreference({
  dataSettingsManager,
}: {
  dataSettingsManager: DataSettingsManager
}) {
  return {
    get: async (): Promise<AppCollectionVisibility | undefined> => {
      const { appCollectionsVisible } = dataSettingsManager.getDataSettings()
      if (appCollectionsVisible === true) {
        return AppCollectionVisibility.VISIBLE
      }
      if (appCollectionsVisible === false) {
        return AppCollectionVisibility.HIDDEN
      }
      return undefined
    },
    set: async (visibility: AppCollectionVisibility): Promise<void> => {
      await dataSettingsManager.updateDataSettings({
        appCollectionsVisible: visibility === AppCollectionVisibility.VISIBLE,
      })
    },
  }
}

export type AppCollectionVisibilityPreferenceCreator =
  typeof createAppCollectionVisibilityPreference

export type AppCollectionVisibilityPreference = ReturnType<
  typeof createAppCollectionVisibilityPreference
>
